import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { HardDrive, Save } from 'lucide-react';
import './Download.css';

const Download = () => {
  const { t } = useLanguage();

  const handleDownload = (type) => {
    // URL de base pour vos téléchargements
    const baseUrl = "https://crazyang.nextworlds.com/downloads";
    
    let fileName = "";
    if (type === 'DSK') {
      fileName = "CrazyAngryBricks_DSK.zip"; 
    } else if (type === 'BIN') {
      fileName = "CrazyAngryBricks_BIN.zip"; 
    }

    if (fileName) {
      // Déclenche le téléchargement
      window.location.href = `${baseUrl}/${fileName}`;
    }
  };

  return (
    <section className="download">
      <h2 className="section-title glow-text">{t('download.title')}</h2>
      <p className="download-description">{t('download.description')}</p>
      
      <div className="download-buttons">
        <div className="download-option">
          <div className="download-icon">
            <HardDrive size={64} color="#00ffff" />
          </div>
          <button 
            className="retro-button"
            onClick={() => handleDownload('DSK')}
          >
            {t('download.dskButton')}
          </button>
          <p className="download-note">{t('download.dskDescription')}</p>
        </div>

        <div className="download-option">
          <div className="download-icon">
            <Save size={64} color="#ff00ff" />
          </div>
          <button 
            className="retro-button download-bin"
            onClick={() => handleDownload('BIN')}
          >
            {t('download.binButton')}
          </button>
          <p className="download-note">{t('download.binDescription')}</p>
        </div>
      </div>
    </section>
  );
};

export default Download;